import { ImpactData } from "../types";
import { useTheme } from "@mui/material";
import { useGetImpactColorUpdated } from "./useGetImpactColorUpdated";
import { ImpactRating } from "./impact-updated";
import { ScoreRating } from "~/operations";
import { getImpactLabelUpdated } from "~/components/impact/Updated/impactUpdatedUtils";

type UseImpactRatioParamsUpdated = {
  impact: ImpactRating;
  adjustedColor?: string;
  isActive: boolean;
};

type UseImpactRatioReturnUpdated = {
  impactData: ImpactData;
  color: string;
  label: ScoreRating;
};

export function useImpactUpdated({
  impact,
  adjustedColor,
  isActive,
}: UseImpactRatioParamsUpdated): UseImpactRatioReturnUpdated {
  const theme = useTheme();

  const color = !isActive
    ? theme.palette.unknown.main
    : useGetImpactColorUpdated(impact.rating);

  const label: ScoreRating = getImpactLabelUpdated(impact.rating);

  // It can be adjusted by success status, skipped/disabled/errored states
  const checkColor = adjustedColor || color;

  function getImpactData(rating: ImpactRating["rating"]): ImpactData {
    let normalizedRating = rating?.toLowerCase();

    if (normalizedRating === "none") {
      return {
        rating: 1,
      };
    } else if (normalizedRating === "low") {
      return {
        rating: 2,
      };
    } else if (normalizedRating === "medium") {
      return {
        rating: 3,
      };
    } else if (normalizedRating === "high") {
      return {
        rating: 4,
      };
    } else if (normalizedRating === "critical") {
      return {
        rating: 5,
      };
    } else if (normalizedRating === "error") {
      return {
        rating: 0,
        isError: true,
      };
    } else {
      // unscored
      return {
        rating: 0,
      };
    }
  }

  return {
    impactData: getImpactData(impact.rating),
    color: checkColor,
    label,
  };
}
